import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client/core';
import authService from '@/services/auth';

const httpLink = new HttpLink({
    uri: 'https://cdcgwswqpbf5tnaodicolreyt4.appsync-api.us-west-2.amazonaws.com/graphql',
});

const authLink = new ApolloLink((operation, forward) => {
    return new Promise((resolve, reject) => {
        try {
            let token = authService.getIdToken();
            operation.setContext({
                headers: {
                    Authorization: token ? token : '',
                },
            });
            resolve(forward(operation));
        } catch (error) {
            console.error('Error in auth link:', error);
            reject(error);
        }
    });
});

const apolloClient = new ApolloClient({
    link: ApolloLink.from([authLink, httpLink]),
    cache: new InMemoryCache(),
});

export async function fetchData( query, queryVariables ) {
    let items = [];
    let gettingData = true;
    let sanityCheck = 0;
    let variables = {limit: 1000, ...queryVariables};
    while (gettingData && sanityCheck !== 50) {
        const response = await apolloClient.query({
            query,
            variables,
            fetchPolicy: 'network-only'
        });
        const key = Object.keys(response.data)[0];
        const newItems = response.data[key].items.map((item) => ({...item}));

        items = items.concat(newItems);
        variables.nextToken = response.data[key].nextToken;
        variables.after = response.data[key].nextToken;
        gettingData = variables.nextToken !== null && newItems.length > 0;
        sanityCheck++;
    }

    if (sanityCheck === 50) {
        throw new Error('Infinite loop detected');
    }

    return items;
}

export async function mutate( mutation, mutationVariables ) {
    const response = await apolloClient.mutate({
        mutation,
        variables: mutationVariables,
    });

    return response.data;
}
